import { render, staticRenderFns } from "./DatosAvisoRenovacion.vue?vue&type=template&id=5e85c6d8&scoped=true&"
import script from "./DatosAvisoRenovacion.vue?vue&type=script&lang=js&"
export * from "./DatosAvisoRenovacion.vue?vue&type=script&lang=js&"
import style0 from "./DatosAvisoRenovacion.vue?vue&type=style&index=0&id=5e85c6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e85c6d8",
  null
  
)

export default component.exports